import classNames from 'classnames';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

export function ChatAvatars({ theme }: { theme: string }) {
  return (
    <div className="flex -space-x-2 overflow-hidden">
      <StaticImage
        className={classNames(
          'inline-block h-5 w-5 overflow-hidden rounded-full',
          {
            'border-2 border-black-100': theme === 'White',
            'border-2 border-red-matte-200': theme === 'Red',
            'border-2 border-green-matte-300': theme === 'Green',
            'border-2 border-blue-500': theme === 'Blue',
            'border-2 border-yellow-matte-200': theme === 'Yellow',
            'border-2 border-black-700': theme === 'Black',
            'border-2 border-white/40': theme === 'Hem X',
          },
        )}
        src="olivia.png"
        alt=""
        height={16}
        width={16}
        formats={['avif', 'webp', 'auto']}
        placeholder="blurred"
      />
      <StaticImage
        className={classNames(
          'inline-block h-5 w-5 overflow-hidden rounded-full',
          {
            'border-2 border-black-100': theme === 'White',
            'border-2 border-red-matte-200': theme === 'Red',
            'border-2 border-green-matte-300': theme === 'Green',
            'border-2 border-blue-500': theme === 'Blue',
            'border-2 border-yellow-matte-200': theme === 'Yellow',
            'border-2 border-black-700': theme === 'Black',
            'border-2 border-white/40': theme === 'Hem X',
          },
        )}
        src="astrid.jpeg"
        alt=""
        height={16}
        width={16}
        formats={['avif', 'webp', 'auto']}
        placeholder="blurred"
      />
      <StaticImage
        className={classNames(
          'inline-block h-5 w-5 overflow-hidden rounded-full',
          {
            'border-2 border-black-100': theme === 'White',
            'border-2 border-red-matte-200': theme === 'Red',
            'border-2 border-green-matte-300': theme === 'Green',
            'border-2 border-blue-500': theme === 'Blue',
            'border-2 border-yellow-matte-200': theme === 'Yellow',
            'border-2 border-black-700': theme === 'Black',
            'border-2 border-white/40': theme === 'Hem X',
          },
        )}
        src="rachel.png"
        alt=""
        height={16}
        width={16}
        formats={['avif', 'webp', 'auto']}
        placeholder="blurred"
      />
    </div>
  );
}
